export { default } from "./CurrencySymbol.jsx";
